import React from 'react';

const DateSeparator = React.memo(({ date }) => {
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '16px 0'
    }}>
      <div style={{
        padding: '4px 12px',
        backgroundColor: '#F2F4F7',
        borderRadius: '12px',
        border: '1px solid #EAECF0'
      }}>
        <span style={{
          fontFamily: 'Poppins',
          fontWeight: '400',
          fontSize: '12px',
          lineHeight: '1.5em',
          color: '#667085'
        }}>
          {formatDate(date)}
        </span>
      </div>
    </div>
  );
});

DateSeparator.displayName = 'DateSeparator';

export default DateSeparator;
